
import React from 'react';

const ConsultationInfo: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-user-star-line',
      title: 'Certified Business Broker',
      description: 'Meet with our experienced and certified business brokers who have helped hundreds of buyers successfully acquire businesses.'
    },
    {
      icon: 'ri-calculator-line',
      title: 'Personalized Assessment',
      description: 'Get a comprehensive evaluation of your business goals, financial capacity, and industry interests tailored to your situation.'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Market Insights',
      description: 'Receive expert insights into current market conditions, business valuations, and acquisition opportunities in your area.'
    },
    {
      icon: 'ri-roadmap-line',
      title: 'Strategic Roadmap',
      description: 'Walk away with a clear roadmap and action plan for your business acquisition journey, including financing options.'
    }
  ];

  const processSteps = [
    'Complete the consultation form',
    'Receive confirmation within 24 hours',
    'Meet with certified broker (30-45 minutes)',
    'Get your personalized acquisition plan'
  ];

  return (
    <div>
      <div className="mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          What to Expect in Your Free Consultation
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          Our free consultation is designed to understand your unique situation, discuss our Premium and Elite program options, and provide you with valuable insights for your business acquisition journey.
        </p>

        <div className="space-y-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start">
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className={`${benefit.icon} text-white text-xl`}></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 p-8 rounded-2xl">
        <h3 className="text-2xl font-bold text-gray-900 mb-6">How It Works</h3>
        <div className="space-y-4">
          {processSteps.map((step, index) => (
            <div key={index} className="flex items-center">
              <div className="w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center mr-4 font-bold text-sm">
                {index + 1}
              </div>
              <span className="text-gray-700">{step}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-8 p-6 bg-teal-50 rounded-2xl border border-teal-200">
        <div className="flex items-start">
          <i className="ri-information-line text-teal-600 text-2xl mr-4 mt-1"></i>
          <div>
            <h4 className="text-lg font-semibold text-teal-800 mb-2">No Obligation</h4>
            <p className="text-teal-700">
              This consultation is completely free with no obligation. We're here to provide valuable insights whether you decide to work with us or not.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Still Have Questions?</h3>
        <div className="space-y-3">
          <div className="flex items-center text-gray-600">
            <i className="ri-phone-line text-teal-500 mr-3"></i>
            <span>Call us at: <strong>(310) 997-6001</strong></span>
          </div>
          <div className="flex items-center text-gray-600">
            <i className="ri-mail-line text-teal-500 mr-3"></i>
            <span>Email: <strong>rroques@fcbb.com</strong></span>
          </div>
          <div className="flex items-center text-gray-600">
            <i className="ri-time-line text-teal-500 mr-3"></i>
            <span>Available: Mon-Fri 9AM-6PM EST</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationInfo;
